module.exports = __webpack_public_path__ + "img/copaAmerica21.0a79834e.jpg";